"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var getChild = function getChild(tree, childPath) {
  var firstNode = tree[childPath[0]];

  if (childPath.length === 1) {
    return firstNode;
  }

  return getChild(firstNode.children, childPath.slice(1, childPath.length));
};

var _default = getChild;
exports["default"] = _default;